import React, { useContext, useEffect } from "react";
import { Cesium1Set, ModeSet, RendouSet } from "../App";
import { HeadingPitchRange } from "cesium";
import { SyukurenSet } from "../App";
import { Rotate1Set } from "../App";
// import { HeadingPitchRange } from "cesium";
import { Area1Set, Area2Set } from "../App";
import { Cartesian3, Math } from "cesium";

export const FuncZoomLatLon = ({rfcs,areaset}) => {
  // const { setRotate1Set } = useContext(Rotate1Set);
  // const { setRendouSet } = useContext(RendouSet);
  // const { setSyukurenSet } = useContext(SyukurenSet);
  // const { cesium1set } = useContext(Cesium1Set);
  const { area1set, setArea1Set } = useContext(Area1Set);
  const { area2set, setArea2Set } = useContext(Area2Set);
  const { modeset, setModeSet } = useContext(ModeSet)

  useEffect(()=>{
    rfcs.current.cesiumElement.camera.flyTo({
      destination: Cartesian3.fromDegrees(139.763, 35.673, 500.0),
      orientation: {
        heading: Math.toRadians(20.0),
        pitch: Math.toRadians(-35.0),
        roll: 0.0,
      },
    });
    // (rfcs.current.cesiumElement.entities);

  },[rfcs,modeset])

return <></>
};